import * as React from "react"

const SvgComponent = ({ ...props }: React.SVGProps<SVGSVGElement>) => {
  const w = 42
  const h = 42
  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_i_4131_322302)">
        <rect x="1" y="1" width="50" height="50" rx="25" fill="#F5F5F5" />
        <rect x="0.5" y="0.5" width="51" height="51" rx="25.5" stroke="white" />
      </g>
      <g filter="url(#filter1_i_4131_322302)">
        <rect x="5.5" y="5.5" width="41" height="41" rx="20.5" fill="#F5F5F5" />
        <path
          d="M25 19L20 23H16V29H20L25 33V19Z"
          stroke="#616161"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33.0691 18.9297C34.9438 20.805 35.9969 23.348 35.9969 25.9997C35.9969 28.6513 34.9438 31.1944 33.0691 33.0697M29.5391 22.4597C30.4764 23.3973 31.003 24.6689 31.003 25.9947C31.003 27.3205 30.4764 28.592 29.5391 29.5297"
          stroke="#616161"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_i_4131_322302"
          x="0"
          y="-10"
          width="52"
          height="62"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-10" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_4131_322302"
          />
        </filter>
        <filter
          id="filter1_i_4131_322302"
          x="5.5"
          y="5.5"
          width="41"
          height="51"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_4131_322302"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default SvgComponent
